export const LOADING_STATES = {
	LOADING: 'loading',
	BENCHMARK: 'benchmark',
	LOADED: 'loaded',
};

export const STEP_TYPES = {
	DESIGN: 'design',
	VARIANT: 'variant',
	OPTION: 'option',
};

export const OPTION_TYPES = {
	ENGRAVEMENT: 'label',
	SELL_WITH: 'sell_with',
	NO_RETURN: 'no_return',
};
